export default "__VITE_ASSET__432cb70d__"